// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"styles_SearchInput__YNpbJ","icon":"styles_icon__PJzkI","clear":"styles_clear__CY7xS","input":"styles_input__2JdhE"};